import { createContext } from 'react'

export interface AuthUser {
  id: string
  email: string
  full_name: string
}

export interface AuthContextType {
  user: AuthUser | null
  token: string | null
  isAuthenticated: boolean
  isGuest: boolean
  loading: boolean
  loginWithGoogle: () => void
  continueAsGuest: () => void
  logout: () => void
}

export const AuthContext = createContext<AuthContextType | null>(null)
